'use strict';

/*global app*/
/*global services*/
/*global invokeCallback*/
/*global createObjectCallBack*/
/*global blockElement*/
/*global unBlockElement*/
/*global K2Modal*/

function K2UserAdditionalLogin(modal) {
  this.modal = modal ? modal : new K2Modal('k2-modal-user-additional-login');

  this.init();
}

K2UserAdditionalLogin.prototype = $.extend({}, {
  constructor: 'K2UserAdditionalLogin',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('.open-user-additional-login').on('click', function () {
      _this.isUserLogined(function () {
        console.log('test');

        //reloadPage();
      }, true);

      return false;
    });
  },

  //----------------------------------------------------------------------------

  doLogin: function doLogin(callback) {
    var _this = this;

    var $content = _this.modal.contentDOM();
    var $form = $content.find('form');

    _this.modal.block();
    $.post($form.attr('action'), $form.serialize(), function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.close();

        _this.setUserLogin(res.data.fullname);
        app.setUserSetting(res.data.setting);

        invokeCallback(callback);
      } else if (res.msg === 'NOT_VALID' || res.msg === 'LOGIN_REQUIRED') {
        _this.initUserLoginForm(res.data, callback);
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  logout: function logout(callback) {
    var _this = this;

    if (services.get('configurations').param('is_required_additional_login')) {
      blockElement($('body'));
      $.get(services.get('router').path('user_additional_login_logout'), function (res) {
        unBlockElement($('body'));

        if (res.msg === 'SUCCESS') {
          _this.invalidateUserLogin();

          invokeCallback(callback);
        } else {
          services.get('notifications').viewErrorMessage(res.error);
        }
      });
    } else {
      invokeCallback(callback);
    }

    return _this;
  },

  initUserLoginForm: function initUserLoginForm(data, callback) {
    var _this = this;

    _this.modal.empty().open({
      title: services.get('translator').trans('login'),
      saveBtnTitle: services.get('translator').trans('login'),
      height: 'auto',
      width: 'md',
      submitCallBack: createObjectCallBack(_this, 'doLogin', callback),
      enterSubmitCallBack: createObjectCallBack(_this, 'doLogin', callback),
      form: true,
      keyboardClose: false,
      buttonsSize: 'lg',
      content: data.html,
      focusInputTimeout: 1000
    });

    if ('initialize' in window) {
      window.initialize(_this.modal.contentDOM());
    }

    setTimeout(function () {
      // musim tady opet volat setFocus, protoze mi o nej prijde, a zatim jsem neprisel proc
      _this.modal.setFocus();
    }, 250);

    return _this;
  },

  isUserLogined: function isUserLogined(callback, forceLogin) {
    var _this = this;

    if (services.get('configurations').param('is_required_additional_login')) {
      blockElement($('body'));
      $.get(services.get('router').path('user_additional_login'), { forceLogin: forceLogin ? 1 : 0 }, function (res) {
        unBlockElement($('body'));

        if (res.msg === 'SUCCESS') {
          app.setUserSetting(res.data.setting);

          invokeCallback(callback);
        } else if (res.msg === 'LOGIN_REQUIRED') {
          _this.initUserLoginForm(res.data, callback);
        } else {
          services.get('notifications').viewErrorMessage(res.error);
        }
      });
    } else {
      invokeCallback(callback);
    }

    return _this;
  },

  invalidateUserLogin: function invalidateUserLogin() {
    var _this = this;

    var $countdown = $('.user-additional-login__countdown');
    $countdown.hide();

    var $icon = $('.user-additional-login__icon');
    var $username = $('.user-additional-login__username');
    $icon.removeClass('text-success');
    $icon.addClass('text-danger');
    $username.text($username.data('username'));

    app.setUserSetting([]);

    return _this;
  },

  setUserLogin: function setUserLogin(username) {
    var _this = this;

    var $icon = $('.user-additional-login__icon');
    var $username = $('.user-additional-login__username');
    $icon.removeClass('text-danger');
    $icon.addClass('text-success');
    $username.text(username);

    _this.resetCountdown();

    return _this;
  },

  resetCountdown: function resetCountdown() {
    var _this = this;

    var $countdown = $('.user-additional-login__countdown');
    var $progressBar = $('.user-additional-login__progress-bar');

    $progressBar.data('actual', $progressBar.data('duration'));
    $progressBar.css('width', '100%');
    $progressBar.removeClass('countdown-init');

    $countdown.show();

    _this.runCountdown();
  },

  runCountdown: function runCountdown() {
    var _this = this;

    var $countdown = $('.user-additional-login__countdown');
    if ($countdown.length && $countdown.is(':visible')) {
      var $progressBar = $('.user-additional-login__progress-bar');
      $progressBar.k2_countdown({
        duration: $progressBar.data('duration'),
        callback: _this.invalidateUserLogin,
        repeat: false
      });
    }

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.runCountdown();

    _this.registerCallbacks();

    return _this;
  }
});
